import LogisticsCost from '../../../../components/editable-cell/form-items/logistics-cost'
import formatNumber from '../../../../helpers/formatters/format-any-number'
import type { ShipmentColumn } from '../../types/column-types'
import { onAnyStandardCell } from '../../helpers/helpers'

export const logisticsCostColumn: ShipmentColumn = {
    key: 'logisticsCost',
    dataIndex: 'logisticsCost',
    title: 'Логистика',
    width: 80,
    editable: true,
    FormItem: <LogisticsCost />,
    onCell: onAnyStandardCell,
    render(value?: number | null) {
        return formatNumber(value ?? 0)
    },
}
